import { logError } from "common/error";
import { Sound as CommonSound } from "common/sound";
import log from "loglevel";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        log.error("audio src is", src);
        logError(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "background":
            return ["background"];
        case "pleaseClick":
            return ["pleaseClick"];
    }
};
const sprite = {
    background: [0 + 5 / 30, 4 + 5 / 30],
    pleaseClick: [4 + 11 / 30, 5 + 14 / 30],
};
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=sound.js.map